import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import color from 'color';
import { TwemojiWrapper } from '../../../components/twemojiWrapper';
const HIGHLIGHT_COLOR_OBJ = color('#339966');
const BASE_CONTAINER_CSS = css `
  padding: 10px;
  color: #aaa;
  flex-grow: 1;
  margin: 5px;
`;
const HIGHLIGHTED_CONTAINER_CSS = css(BASE_CONTAINER_CSS, css `
    border: 2px solid ${HIGHLIGHT_COLOR_OBJ.hex()};
    border-radius: 10px;
    background-color: rgba(
      ${HIGHLIGHT_COLOR_OBJ.red()},
      ${HIGHLIGHT_COLOR_OBJ.green()},
      ${HIGHLIGHT_COLOR_OBJ.blue()},
      0.2
    );
  `);
const TITLE_CSS = css `
  color: white;
`;
const DESCRIPTION_CSS = css `
  margin-left: 20px;
`;
const UL_CSS = css `
  margin: 0;
`;
const DATE_CSS = css `
  color: #888;
`;
export const NewsItemDisplay = ({ newsItem, isHighlighted }) => {
    const { dateString, title, items, content, description } = newsItem;
    const containerCss = isHighlighted ? HIGHLIGHTED_CONTAINER_CSS : BASE_CONTAINER_CSS;
    return (_jsx("div", { css: containerCss, "aria-label": 'news item', children: _jsxs(TwemojiWrapper, { children: [_jsx(Typography, { component: 'div', variant: 'subtitle2', css: TITLE_CSS, children: title || 'Updates' }), description && (_jsx("div", { css: DESCRIPTION_CSS, children: _jsx(Typography, { component: 'div', variant: 'subtitle2', children: description }) })), items && items.length && (_jsx(Typography, { component: 'div', variant: 'subtitle2', children: _jsx("ul", { css: UL_CSS, children: items.map((item, i) => (_jsx("li", { children: item }, i))) }) })), content && (_jsx(Typography, { component: 'div', variant: 'subtitle2', children: content })), _jsx(Typography, { component: 'div', variant: 'subtitle2', css: DATE_CSS, children: dateString })] }) }));
};
